import React from 'react';
import styled from 'styled-components';
import { Box, CloseButton, get, Space, TextBody, TextHeading, } from '@ally/metronome-ui';
import { AllyAppQRCode } from '../Svgs';
const headingRef = React.createRef();
const NumberCircle = styled(Box) `
  border-radius: 50%;
  width: 25px;
  height: 25px;
  background: ${get.colors('plum')};
  border: none;
  color: ${get.colors('white')};
  text-align: center;
  padding-top: 2px;
`;
const SetItUpContainer = styled(Box) `
  display: grid;
  grid-gap: 5px;
  grid-auto-rows: auto;
  align-items: flex-start;
  ${get.media.down('lg')} {
    display: block;
  }
`;
const DownloadAppInfoContainer = styled(Box) `
  display: flex;
  grid-column: 1;
  row-gap: 10px;
  border-right: 1px solid ${get.colors('grey-80')};
  margin-left: 15px;
  padding-right: 25px;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  height: 100%;
  ${get.media.down('lg')} {
    margin-left: 0;
    border-right: none;
    padding-right: 0;
    margin-bottom: 8px;
    text-align: center;
  }
`;
const DefaultToPushNotificationContainer = styled(Box) `
  display: flex;
  grid-column: 2;
  row-gap: 10px;
  border-right: 1px solid ${get.colors('grey-80')};
  margin-left: 30px;
  padding-right: 30px;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  height: 100%;
  ${get.media.down('lg')} {
    margin-left: 0;
    padding-right: 0;
    border-right: none;
    margin-bottom: 24px;
    text-align: center;
  }
`;
const StyledBox = styled(Box) `
  width: 100px;
  height: 100px;
`;
const VerifyFutureLoginContainer = styled(Box) `
  display: flex;
  grid-column: 3;
  row-gap: 10px;
  margin-left: 30px;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  height: 100%;
  ${get.media.down('lg')} {
    margin-left: 0;
    text-align: center;
  }
`;
const StyledContentWrapper = styled(Box) `
  max-width: 776px; // based on the metronome-ui Modal component, the util to compute this is not exported
`;
export const HowToSetUpPushApproveContent = ({ onCtaLinkClicked, }) => {
    return (React.createElement(StyledContentWrapper, null,
        React.createElement(Space, { mb: "md" },
            React.createElement(TextHeading, { "data-testid": "how-to-set-it-up-modal-header", ref: headingRef, tabIndex: -1, tag: "h1", size: "md" }, "Here's how to set it up")),
        React.createElement(Space, { mb: "lg" },
            React.createElement(TextBody, { tag: "p", size: "md" }, "Defaulting to push notification boosts your account security and helps prevent people from logging into your account.")),
        React.createElement(Space, { mb: "lg" },
            React.createElement(SetItUpContainer, { alignItems: "center" },
                React.createElement(DownloadAppInfoContainer, null,
                    React.createElement(NumberCircle, { alignItems: "center" }, "1"),
                    React.createElement(TextBody, { tag: "p", size: "md", weight: "bold" }, "Download the Ally app"),
                    React.createElement(Space, { mb: "md" },
                        React.createElement(StyledBox, { alignItems: "center" },
                            React.createElement(AllyAppQRCode, null)))),
                React.createElement(DefaultToPushNotificationContainer, null,
                    React.createElement(NumberCircle, { alignItems: "center" }, "2"),
                    React.createElement(TextBody, { tag: "p", size: "md", weight: "bold" }, "Default to push notification"),
                    React.createElement(TextBody, { tag: "p", size: "sm" },
                        "Log into the app, select ",
                        React.createElement("strong", null, "Profile,"),
                        " then",
                        ' ',
                        React.createElement("strong", null, "Login Security"),
                        " and make sure push notification is enabled.")),
                React.createElement(VerifyFutureLoginContainer, null,
                    React.createElement(NumberCircle, { alignItems: "center" }, "3"),
                    React.createElement(TextBody, { tag: "p", size: "md", weight: "bold" }, "Verify future logins"),
                    React.createElement(TextBody, { tag: "p", size: "sm" }, "You'll be able to tap the number on your phone that matches the one on your web login screen to confirm it's you, or tell us not to allow it and immediately change your password.")))),
        onCtaLinkClicked && (React.createElement(CloseButton, { onClick: () => {
                onCtaLinkClicked();
            } }))));
};
//# sourceMappingURL=HowToSetUpPushApproveContent.js.map